export enum ManualSectionType {    
    ApiManual = "api",
}
